export default "__VITE_ASSET__BA$e6P5b__"